import { useState, useEffect } from 'react';
import axios from 'axios';
import { parseGameHTML } from '@/util/Parsing';


function FetchData({ children, season, gameId }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  const IS_PLAYOFFS = season.includes('Playoffs');
  const URL = `https://othl.ca/File/${season}/OTHL-${IS_PLAYOFFS ? 'PLF-' : ''}${gameId}.html`;

  useEffect(() => {
    axios.get(URL)
      .then(response => parseGameHTML(response.data, IS_PLAYOFFS))
      .then(response => {
        setResponse(response);
        setLoading(false);
      })
      .catch(error => setError(error))
  }, [IS_PLAYOFFS, URL]);

  return children({ url: URL, loading, error, response });
}

export default FetchData;